/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Loading_VimeoInputs */

const en_load_project_file_status_loading_vimeo = /** @type {(inputs: Load_Project_File_Status_Loading_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading Vimeo Video...`)
};

const fr_load_project_file_status_loading_vimeo = /** @type {(inputs: Load_Project_File_Status_Loading_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de la video Vimeo...`)
};

const de_load_project_file_status_loading_vimeo = /** @type {(inputs: Load_Project_File_Status_Loading_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo-Video wird geladen...`)
};

const it_load_project_file_status_loading_vimeo = /** @type {(inputs: Load_Project_File_Status_Loading_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento video Vimeo in corso...`)
};

const ru_load_project_file_status_loading_vimeo = /** @type {(inputs: Load_Project_File_Status_Loading_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка видео с Vimeo...`)
};

const es_load_project_file_status_loading_vimeo = /** @type {(inputs: Load_Project_File_Status_Loading_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando video de Vimeo...`)
};

const zh_cn2_load_project_file_status_loading_vimeo = /** @type {(inputs: Load_Project_File_Status_Loading_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载 Vimeo 视频...`)
};

const ja_load_project_file_status_loading_vimeo = /** @type {(inputs: Load_Project_File_Status_Loading_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo ビデオを読み込んでいます...`)
};

const hi_load_project_file_status_loading_vimeo = /** @type {(inputs: Load_Project_File_Status_Loading_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo वीडियो लोड हो रहा है...`)
};

const pt_pt2_load_project_file_status_loading_vimeo = /** @type {(inputs: Load_Project_File_Status_Loading_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando vídeo do Vimeo...`)
};

/**
* | output |
* | --- |
* | "Loading Vimeo Video..." |
*
* @param {Load_Project_File_Status_Loading_VimeoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_loading_vimeo = /** @type {((inputs?: Load_Project_File_Status_Loading_VimeoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Loading_VimeoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_status_loading_vimeo(inputs)
	if (locale === "de") return de_load_project_file_status_loading_vimeo(inputs)
	if (locale === "it") return it_load_project_file_status_loading_vimeo(inputs)
	if (locale === "ru") return ru_load_project_file_status_loading_vimeo(inputs)
	if (locale === "es") return es_load_project_file_status_loading_vimeo(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_status_loading_vimeo(inputs)
	if (locale === "ja") return ja_load_project_file_status_loading_vimeo(inputs)
	if (locale === "hi") return hi_load_project_file_status_loading_vimeo(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_status_loading_vimeo(inputs)
	return en_load_project_file_status_loading_vimeo(inputs)
});